module.exports = __webpack_public_path__ + "img/sol_2.bbaba974.jpg";